<template>
  <div class="flex flex-col gap-[20px]">
    <label
      class="text-[16px] leading-[24px] font-semibold text-[#121212] flex items-center gap-1"
      style="font-family: 'Open Sans'; font-weight: 600"
    >
      {{ label }}
      <span
        v-if="required"
        class="text-[#E25C5C] font-[500] text-[16px] leading-[24px]"
        >*</span
      >
    </label>
    <div class="flex flex-row gap-[20px]">
      <img :src="imagePreview" :alt="label" class="w-20 h-20" />
      <div class="h-[71px] flex flex-col gap-[8px] my-1">
        <div class="flex items-center gap-[8px]">
          <input
            type="file"
            @change="handleFileUpload"
            class="hidden"
            ref="fileInput"
            accept="image/png, image/jpeg"
          />
          <button
            class="w-[104px] h-[42px] border border-[#00423D] rounded-[8px] px-[24px] py-[9px] text-[16px] font-semibold leading-[24px] text-[#00423D]"
            style="font-family: 'Open Sans'; font-weight: 600"
            @click="$refs.fileInput.click()"
          >
            Upload
          </button>
        </div>
        <p
          v-if="errorMessage"
          class="text-red-500 text-[14px] font-medium leading-[21px]"
        >
          {{ errorMessage }}
        </p>
        <p
          class="text-[14px] font-medium leading-[21px] text-[#666666] font-roobert"
        >
          {{ fileInfoText }}
        </p>
      </div>
    </div>
  </div>
</template>
  
  <script setup>
import { ref, watch, defineProps, defineEmits } from "vue";
import defaultLogo from "@/assets/upload_logo.svg";
//   import defaultUserImage from "@/assets/default_user.svg";

const props = defineProps({
  modelValue: String, // v-model support
  label: { type: String, default: "Upload Image" },
  placeholder: { type: String, default: defaultLogo },
  errorMessage: { type: String, default: "" },
  fileInfoText: {
    type: String,
    default: "JPG or PNG Max Size of 1MB at least 400px by 400px.",
  },
  required: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue"]);

const imagePreview = ref(props.modelValue || props.placeholder);
const fileInput = ref(null);

const handleFileUpload = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  if (file.size > 1024 * 1024) {
    alert("File size should be less than 1MB");
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    imagePreview.value = e.target.result;
    emit("update:modelValue", e.target.result);
  };
  reader.readAsDataURL(file);
};

watch(
  () => props.modelValue,
  (newValue) => {
    imagePreview.value = newValue || props.placeholder;
  }
);
</script>
  